import { useContext, useEffect } from 'react';
import type { Navigator } from 'react-router-dom';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

type Transition = {
  retry(): void;
};

type Blocker = (tx: Transition) => void;

interface NavigatorWithBlock extends Navigator {
  block: (cb: (tx: Transition) => void) => () => void;
}

export function useBlocker(blocker: Blocker, when = true): void {
  const navigator = useContext(NavigationContext).navigator as NavigatorWithBlock;

  useEffect(() => {
    if (!when) return undefined;

    const unblock = navigator.block((tx) => {
      const autoUnblockingTx: Transition = {
        retry() {
          unblock();
          tx.retry();
        },
      };

      blocker(autoUnblockingTx);
    });

    return () => unblock();
  }, [navigator, blocker, when]);
}
